module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"error.invalid.checklist_type.title":"ใบซ่อมไม่รองรับ Drone รุ่นนี้","error.invalid.checklist_type.message":"ใบซ่อมสำหรับ Drone รุ่นนี้ ยังไม่รองรับ ({type}) , ติดต่อทางผู้ดูแลระบบเพื่อปรับปรุง"}}')
  delete Component.options._Ctor
}
